module.exports = __webpack_public_path__ + "img/shop.3c2453c6.svg";